import { isNil } from 'lodash/fp';
import { type ColumnBlockDataFragment } from '../../../../../api/fragments/ColumnBlockData';
import usePublic from '../../../../../utilities/usePublic';
import useTranslatedString from '../../../../../utilities/useTranslatedString';
import StyledCard, { StyledImage, StyledMeta } from '../shared';

type ColumnCardProps = {
    columns: ColumnBlockDataFragment[];
};

const ColumnCard = ({ columns }: ColumnCardProps) => {
    const fallbackSrc = usePublic('empty.svg');
    const translated = useTranslatedString();

    return (
        <>
            {columns.map(column => (
                <StyledCard
                    cover={<StyledImage preview={false} src={!isNil(column.image) ? column.image.url : fallbackSrc} />}
                >
                    <StyledMeta
                        description={translated(column.description)}
                        title={<h4>{translated(column.title)}</h4>}
                    />
                </StyledCard>
            ))}
        </>
    );
};

export default ColumnCard;
